import React, { Component } from 'react'
import { connect } from 'react-redux'
import firebase from 'firebase/app'
import { Form, Button, Modal, Header, Icon } from 'semantic-ui-react'

import AuthActions from '../../reducers/authReducer'

class UserForm extends Component {
  state = {
    username: '',
    email: '',
    role: '',
    region: 'pnh',
    manageMerchantIds: [],
    loading: false,
  }

  componentDidMount() {
    const { user, isOperator = false, isMerchantAdmin = false } = this.props

    if (user) {
      const { username, email, role, region, manageMerchantIds } = user

      this.setState({
        role,
        email,
        region,
        username,
        manageMerchantIds: manageMerchantIds || [],
      })
    }

    if (isOperator) {
      this.setState({ role: 'operator@role' })
    }
    if (isMerchantAdmin) {
      this.setState({ role: 'merchant_admin@role' })
    }
  }

  updateUser = async () => {
    const { uid, auth, setAuthData } = this.props
    const { role, username, manageMerchantIds, region } = this.state
    const doc = firebase.firestore().collection('dashboard_users').doc(uid)

    await doc.update({ role, username, manageMerchantIds, region })

    if (uid === auth.uid) {
      setAuthData({ ...auth, region })
    }

    return true
  }

  createUser = async () => {
    const { username, email, role, region, manageMerchantIds } = this.state

    const functions = firebase
      .app()
      .functions('asia-northeast1')
      .httpsCallable('createDashboardUser')

    return functions({ username, email, region, role, manageMerchantIds })
  }

  onSubmit = async () => {
    const { uid, onClose } = this.props
    const action = uid ? this.updateUser : this.createUser

    try {
      this.setState({ loading: true })
      await action()
    } catch (error) {
      console.log(error.response || error)
    } finally {
      this.setState({ loading: false })
      onClose()
    }
  }

  getDisplayRoles = () => {
    const { roles } = this.props
    const roleKeys = Object.keys(roles)
    const displayRoles = []

    for (let i = 0; i < roleKeys.length; i += 1) {
      const roleKey = roleKeys[i]
      const role = roles[roleKey]
      const fixedRoles = ['operator@role', 'merchant_admin@role']
      const isArchived = role.archived || fixedRoles.includes(roleKey)

      if (!isArchived) {
        displayRoles.push({
          key: roleKey,
          text: role.name,
          value: roleKey,
        })
      }
    }

    return displayRoles
  }

  getDisplayMerchants = () => {
    const { restaurants } = this.props
    const restKeys = Object.keys(restaurants)
    const displayMerchants = []

    for (let i = 0; i < restKeys.length; i += 1) {
      const restKey = restKeys[i]
      const rest = restaurants[restKey]
      const isArchived = rest.status === 'archived'
      if (!isArchived) {
        displayMerchants.push({
          key: restKey,
          text: rest.name,
          value: restKey,
        })
      }
    }

    return displayMerchants
  }

  render() {
    const { email, role, manageMerchantIds, username, region, loading } = this.state
    const { isOperator, isMerchantAdmin, visible, onClose, user, regions } = this.props
    const title = user ? `Edit ${user.username}` : 'Add new user'
    const displayRoleSelect = isOperator || isMerchantAdmin
    const roles = this.getDisplayRoles()
    const merchants = this.getDisplayMerchants()

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content={title} />
        <Modal.Content style={{ maxHeight: 500, overflow: 'auto' }} className="branch-form">
          <Form
            onSubmit={this.onSubmit}
            ref={ref => {
              this.formRef = ref
            }}
            disabled={loading}
          >
            {!displayRoleSelect && (
              <Form.Group widths="equal">
                <Form.Select
                  label="Role"
                  options={roles}
                  placeholder="Select User Role"
                  value={role}
                  required
                  onChange={(e, data) => this.setState({ role: data.value })}
                />
              </Form.Group>
            )}
            {isMerchantAdmin && (
              <Form.Group widths="equal">
                <Form.Select
                  multiple
                  search
                  label="Merchant"
                  options={merchants}
                  placeholder="Select Merchant"
                  value={manageMerchantIds}
                  required={role === 'merchant_admin@role'}
                  onChange={(e, data) => this.setState({ manageMerchantIds: data.value })}
                />
              </Form.Group>
            )}
            {!isMerchantAdmin && (
              <Form.Group widths="equal">
                <Form.Select
                  label="Regions"
                  options={regions.map(region => ({ key: region.id, text: region.name, value: region.id }))}
                  placeholder="Select User Initial Region"
                  value={region}
                  required
                  onChange={(e, data) => this.setState({ region: data.value })}
                />
              </Form.Group>
            )}
            <Form.Group widths="equal">
              <Form.Input
                label="Username"
                name="user-username"
                placeholder="Username"
                value={username}
                type="text"
                autoComplete="false"
                required
                onChange={e => this.setState({ username: e.target.value })}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                disabled={!!user}
                label="Email"
                placeholder="Email"
                value={email}
                type="email"
                name="user-email"
                required
                autoComplete="false"
                onChange={e => this.setState({ email: e.target.value })}
              />
            </Form.Group>
            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapState = ({ rolePermission, restaurants, regions, auth }) => ({
  roles: rolePermission.roles,
  restaurants: restaurants.data,
  regions: regions.data,
  auth: auth.data,
})

const mapDispatch = {
  setAuthData: AuthActions.setAuthData,
}

export default connect(mapState, mapDispatch)(UserForm)



// WEBPACK FOOTER //
// ./src/containers/users/form.js